var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,12.42c-34.56,0-62.58,28.02-62.58,62.58s28.02,62.58,62.58,62.58c34.56,0,62.58-28.02,62.58-62.58S109.56,12.42,75,12.42ZM54.28,62.44v47.33h0s-14.09,0-14.09,0h0s0-47.33,0-47.33h14.09ZM55.68,46.95c0,4.71-3.82,8.53-8.53,8.53-4.71-.1-8.44-4-8.34-8.71,0,0,0,0,0,0,0,0,0,0,0,0,.1-4.57,3.78-8.24,8.34-8.34,4.71,0,8.53,3.82,8.53,8.53,0,0,0,0,0,0s0,0,0,0ZM109.79,77.92v31.84h0s-13.92,0-13.92,0h0v-25.58c-.17-5.39-3.83-9.57-9.22-9.57-5.39-.05-9.86,4.18-10.09,9.57v25.57h0s-13.92,0-13.92,0v-47.33h0s13.92,0,13.92,0h0v6.61c3-4.47,8.02-7.14,13.4-7.13h3.83c8.83.04,15.97,7.18,16.01,16.01h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedInIcon.74f62f785a23c3b117b933284cf82fb6.svg";
export { ForwardRef as ReactComponent };